<template>
  <div class="dataRooms">

    <el-row :gutter="20">
      <el-col :span="10" :offset="0">

        <el-row :gutter="20" style="margin-bottom: 20px;">
          <el-col :span="19" :offset="0">
            <el-select v-model="select" placeholder="Select Data Room" clearable filterable size="mini" style="width: 100%;">
              <el-option v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="5" :offset="0">
            <el-button size="small" type="menu" icon="el-icon-edit-outline" :disabled="true" style="width: 100%;">{{$t('project_dropdown_action')}}</el-button>
          </el-col>
        </el-row>

        <ag-grid-vue
          style="width: 100%; height: 805px;"
          :gridOptions="gridOptions"
          :defaultColDef="defaultColDef"
          @grid-ready="onGridReady"
          id="myGrid"
          class="ag-theme-balham"
          :getRowHeight="getRowHeight"
          :rowDragManaged="true"
          :animateRows="true"
          :columnDefs="columnDefs"
          :rowSelection="rowSelection"
          :floatingFilter="true"
          :rowData="rowData">
        </ag-grid-vue>

      </el-col>
      <el-col :span="14" :offset="0">

        <el-tabs v-model="activeTab" activeName="info" disabled type="border-card" @tab-click="handleClick" style="padding-top: 50px;">
            
            <!-- Info -->
            <el-tab-pane :label="$t('users_tab_info')" name="info">
              <el-tabs activeName="details">
                <el-tab-pane label="Details" name="details">
                  <el-card>
                    
                    <el-row :gutter="20" style="margin-bottom: 5px;">
                      <el-col :span="6" :offset="0">
                        <div style="font-weight: bold;">Data Room No.:</div>
                      </el-col>
                      <el-col :span="18" :offset="0">
                        DR-001
                      </el-col>
                    </el-row>
                    
                    <el-row :gutter="20" style="margin-bottom: 5px;">
                      <el-col :span="6" :offset="0">
                        <div style="font-weight: bold;">Data Room Name:</div>
                      </el-col>
                      <el-col :span="18" :offset="0">
                        DR - Organisation Commercial
                      </el-col>
                    </el-row>

                    <el-row :gutter="20" style="margin-bottom: 5px;">
                      <el-col :span="6" :offset="0">
                        <div style="font-weight: bold;">Created By:</div>
                      </el-col>
                      <el-col :span="18" :offset="0">
                        Jeff Nuttall
                      </el-col>
                    </el-row>

                    <el-row :gutter="20" style="margin-bottom: 5px;">
                      <el-col :span="6" :offset="0">
                        <div style="font-weight: bold;">Assigned To:</div>
                      </el-col>
                      <el-col :span="18" :offset="0">
                        
                      </el-col>
                    </el-row>

                    <div style="height: 200px;"></div>

                    <el-row :gutter="20">
                      <el-col :span="8" :offset="0" style="border-right: 1px solid #EBEEF5; height: 100px;">
                        <div style="margin-bottom: 10px; font-weight: bold;">Data Room Team:</div>
                        <div>Aillen Sangcap</div>
                        <div>Jeff Nuttall</div>
                      </el-col>
                      <el-col :span="8" :offset="0" style="border-right: 1px solid #EBEEF5; height: 100px;">
                        <div style="margin-bottom: 10px; font-weight: bold;">Data Room Clients:</div>
                        <div>Autors Schneider</div>
                      </el-col>
                      <el-col :span="8" :offset="0">
                        <div style="margin-bottom: 10px; font-weight: bold;">Data Room Vendors:</div>
                        <div>Elevator Logistics Pty Ltd</div>
                      </el-col>
                    </el-row>

                  </el-card>
                </el-tab-pane>
                <el-tab-pane label="About" name="about" :disabled="true">
                  <el-card>
                    Current Service Under Development
                  </el-card>
                </el-tab-pane>
                <el-tab-pane label="History" name="history" :disabled="true">
                  <el-card>
                    Current Service Under Development
                  </el-card>
                </el-tab-pane>
                <el-tab-pane label="Permissions" name="permissions" :disabled="true">
                  <el-card>
                    Current Service Under Development
                  </el-card>
                </el-tab-pane>
              </el-tabs>
            </el-tab-pane>

            <!-- Files -->
            <el-tab-pane label="Files" name="files" :disabled="true">
              <el-tabs>
                Current Service Under Development
              </el-tabs>
            </el-tab-pane>

            <!-- Comments -->
            <el-tab-pane label="Comments" name="comments" :disabled="true">
              <el-tabs>
                Current Service Under Development
              </el-tabs>
            </el-tab-pane>

            <!-- Messages -->
            <el-tab-pane label="Messages" name="messages" :disabled="true">
              <el-tabs>
                Current Service Under Development
              </el-tabs>
            </el-tab-pane>

            <!-- Meetings -->
            <el-tab-pane label="Meetings" name="meetings" :disabled="true">
              <el-tabs>
                Current Service Under Development
              </el-tabs>
            </el-tab-pane>

          </el-tabs>
      </el-col>
    </el-row>

  </div>
</template>

<script>
import { AgGridVue } from 'ag-grid-vue';
import axios from 'axios'
export default {
  name: 'dataRooms',
  components: {
    AgGridVue
  },
  created() {
    
  },
  beforeMount() {
    this.gridOptions = {
      suppressCellSelection: true
    };
    this.columnDefs = [
      { 
        headerName: "", 
        field: 'id',
        filter: false,
        headerClass: 'id-column',
        tooltipComponentParams: { fieldName: "Index" },
        cellRenderer: function(params) {
          return `<span class="txtRender">${params.node.data.id}</span>`
        },
        cellStyle: function(params) {
          return {'text-align': 'center; display: flex; justify-content:center;'}
        },
        width: 10,
      },
      { 
        headerName: "Name", 
        field: 'name',
        filter: "agTextColumnFilter",
        cellStyle: function(params) {
          return {'text-align': 'center; display: flex;'}
        },
        cellRenderer: function(params) {
          return `<span class="txtRender">${params.node.data.name}</span>`
        },
      }
    ];  

    this.rowData = [
      { id: '1', name: 'Basic Corporate Documents' },
      { id: '2', name: 'Capital Stock and Other Securities' },
      { id: '3', name: 'Financial and Tax Matters' }
    ];
    this.rowSelection = "multiple"
    this.defaultColDef = {
      suppressMovable: true,
      suppressMenu: true,
      resizable: true,
      // width: 150,
      filter: true
    };
    this.getRowHeight = params => {
      return 40;
    };
  },
  data() {
    return {
      select: '',
      options: [],

      activeTab: 'info',

      rowSelection: null,
      columnDefs: null,
      getRowHeight:null,
      rowData: null,
      gridOptions: null,
      defaultColDef: null
    }
  },
  methods: {
    handleClick(tab, event) {
      
    },
    onGridReady(params) {
      params.api.sizeColumnsToFit();
    },
    notification(title, message, type) {
      this.$notify({
        title: title,
        message: message,
        type: type
      });
    },
  },
}
</script>

<style lang="scss" scoped>
.dataRooms {
  background: #DfE8F0;
  height: 100vh;
  padding: 60px 10px 10px;
}

/deep/.el-tabs--border-card>.el-tabs__content {
  height: 82vh !important;
}
</style>
